import { Injectable } from "@angular/core";
import { LocationCategoriesAPIService } from "../../../../shared/services/API/LocationCategoriesAPI.service";
import { LocationCategoryDTO } from "../models/LocationCategoryDTO";

@Injectable({
    providedIn: 'root'
  })

export class LocationCategoriesService {

  categories: LocationCategoryDTO[] = [];

  constructor(
    private locationCategoriesService: LocationCategoriesAPIService){
  }

  getList(){
    return this.locationCategoriesService.getList();
  }

  getCategoryStatusList(idLocationCategory: number){
    return this.locationCategoriesService.getCategoryStatusList(idLocationCategory);
  }

}
